export default "__VITE_PUBLIC_ASSET__6a267f47__"